import React, {Component} from 'react'
import {toJS} from 'mobx'
import {inject, observer} from 'mobx-react'
import { Modal, Descriptions, Slider, Row, Col, Divider, Input, Checkbox, Typography } from 'antd'
import {withTranslation} from 'react-i18next'
import { CaretRightOutlined, PauseOutlined, HistoryOutlined } from '@ant-design/icons'
import './index.less'
const { Text } = Typography;

@inject('manualOutboundCallStore')
@observer
class FormModal extends Component {
  state = {
    isPlaying: false,
    currentTime: 0,
    duration: 0,
  }

  audioRef = React.createRef()

  componentDidMount() {
  }

  handlePlayPause = () => {
    const { manualOutboundCallStore } = this.props
    const {detailsObj} = manualOutboundCallStore
    const { isPlaying } = this.state
    const audio = this.audioRef.current
    
    if (!audio || !detailsObj?.obsUrl) return

    if (isPlaying) {
      audio.pause()
    } else {
      audio.play().catch(err => {
        console.error('Audio play error:', err)
        this.setState({ isPlaying: false })
      })
    }
    
    this.setState({ isPlaying: !isPlaying })
  }

  handleTimeUpdate = () => {
    const audio = this.audioRef.current
    if (audio) {
      this.setState({
        currentTime: audio.currentTime,
        duration: audio.duration && !isNaN(audio.duration) ? audio.duration : 0
      })
    }
  }

  handleSliderChange = (value) => {
    const audio = this.audioRef.current
    if (audio) {
      audio.currentTime = value
      this.setState({ currentTime: value })
    }
  }

  handleAudioEnded = () => {
    this.setState({
      isPlaying: false,
      currentTime: 0
    })
  }

  handleLoadedMetadata = () => {
    const audio = this.audioRef.current
    if (audio) {
      this.setState({
        duration: audio.duration && !isNaN(audio.duration) ? audio.duration : 0
      })
    }
  }

  formatTime = (seconds) => {
    if (!seconds || isNaN(seconds)) return '00:00'
    const mins = Math.floor(seconds / 60)
    const secs = Math.floor(seconds % 60)
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
  }

  render() {
    const { manualOutboundCallStore, addModalVisible, handleCancel, t } = this.props
    const {detailsObj} = manualOutboundCallStore
    const { isPlaying, currentTime, duration } = this.state

    return (
      <>
        <Modal
          title={t(`outboundCall.viewDetails`)}
          closable={true}
          visible={addModalVisible}
          onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          width={'46%'}
          centered
          footer={null}
          bodyStyle={{ padding: '24px 32px' }}
        >
          <Descriptions column={1} className='call-details'>
            <Descriptions.Item 
              label={t(`outboundCall.callNumber`)}
              labelStyle={{ fontSize: '16px' }}
              contentStyle={{ fontWeight: 'bold', fontSize: '16px' }}
            >
              {detailsObj?.visitorPhone}
            </Descriptions.Item>
            <Descriptions.Item 
              label={t(`outboundCall.dialogueRecording`)}
              labelStyle={{ fontSize: '16px' }}
            >
              <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: '12px',
                background: '#f0f5ff',
                padding: '0 16px',
                borderRadius: '4px',
                width: '100%',
                height: '100%',
              }}>
                <div>
                  <span style={{ 
                    fontSize: '14px', 
                    color: '#1890ff',
                  }}>{this.formatTime(currentTime)}</span> / <span style={{ 
                    fontSize: '14px', 
                    color: '#000',
                  }}>{this.formatTime(duration)}</span>
                </div>
                <div style={{ flex: 1, display: 'flex', alignItems: 'center', margin: '0 8px' }}>
                  <Slider
                    value={currentTime}
                    max={duration || 1}
                    onChange={this.handleSliderChange}
                    style={{ width: '100%', margin: 0 }}
                    disabled={!detailsObj?.obsUrl}
                    tooltip={{ open: false }}
                    trackStyle={{ background: '#1890ff' }}
                    handleStyle={{
                      borderColor: '#1890ff',
                      backgroundColor: '#fff',
                      width: '12px',
                      height: '12px',
                      marginTop: '-4px'
                    }}
                    railStyle={{ background: '#d9d9d9' }}
                  />
                </div>
                <div
                  onClick={this.handlePlayPause}
                  style={{
                    width: '20px',
                    height: '20px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: detailsObj?.obsUrl ? 'pointer' : 'not-allowed',
                    transition: 'all 0.3s',
                    opacity: detailsObj?.obsUrl ? 1 : 0.5
                  }}
                  className={detailsObj?.obsUrl ? 'hover-scale' : ''}
                >
                  {isPlaying ? (
                    <PauseOutlined style={{ fontSize: '14px', color: '#000' }} />
                  ) : (
                    <CaretRightOutlined style={{ fontSize: '14px', color: '#000', marginLeft: '2px' }} />
                  )}
                </div>
                <audio
                  ref={this.audioRef}
                  src={detailsObj?.obsUrl}
                  onTimeUpdate={this.handleTimeUpdate}
                  onLoadedMetadata={this.handleLoadedMetadata}
                  onEnded={this.handleAudioEnded}
                  onError={(e) => {
                    console.error('Audio error:', e)
                    this.setState({ isPlaying: false })
                  }}
                />
              </div>
            </Descriptions.Item>
          </Descriptions>
          {detailsObj?.remark?.length>0 && <Descriptions
            bordered
            column={2}
            size='small'
            style={{marginBottom: 0}}
            className='call-question'
          >
            {detailsObj?.remark?.map((a, ii) => (
              <Descriptions.Item key={ii} label={
                <Text
                  style={{width: 100}}
                  ellipsis={{
                    tooltip: a.question_name,
                  }}
                >
                  { a.question_name }
                </Text>
              }>
                <Text
                  style={{width: 100}}
                  ellipsis={{
                    tooltip: Array.isArray(toJS(a.data)) ? a.data?.join(', ') : a.data,
                  }}
                >
                  { Array.isArray(toJS(a.data)) ? a.data?.join(', ') : a.data }
                </Text>
              </Descriptions.Item>
            ))}
          </Descriptions>}
          {detailsObj?.historyRemarks?.length > 0 ? <>
            <Divider />
            <div className='leftTit' style={{ marginBottom: 10}}>{t(`outboundCall.historySurvey`)}</div>
            <div className='call-history'>
              {detailsObj?.historyRemarks.map((item, i) => (
                <Descriptions
                  bordered
                  title={<>
                    <div style={{
                      width: '20px',
                      height: '20px',
                      lineHeight: '18px',
                      textAlign: 'center',
                      background: '#979797',
                      borderRadius: '4px',
                      display: 'inline-block',
                      marginRight: '8px'
                    }}>
                      <HistoryOutlined  style={{fontSize: '12px', color: '#ffffff'}} />
                    </div>
                    {item?.createUser}
                  </>}
                  extra={<span style={{color: '#bfbfbf'}}>{item?.createTime}</span>}
                  key={i}
                  column={2}
                  size='small'
                >
                  {item.questionContent.map((a, ii) => (
                    <Descriptions.Item key={ii} label={
                      <Text
                        style={{width: 100}}
                        ellipsis={{
                          tooltip: a.question_name,
                        }}
                      >
                        { a.question_name }
                      </Text>
                    }>
                        <Text
                          style={{width: 100}}
                          ellipsis={{
                            tooltip: Array.isArray(toJS(a.data)) ? a.data?.join(', ') : a.data,
                          }}
                        >
                          { Array.isArray(toJS(a.data)) ? a.data?.join(', ') : a.data }
                        </Text>
                      </Descriptions.Item>
                  ))}
                </Descriptions>
              ))}
            </div>
          </> : null}
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModal)
